module.exports = __webpack_public_path__ + "static/comingsoondisc-237afb95bb18f82eb56b734690349a68.jpeg";